import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { generateGameUrl, useGameUrlPayload } from '@swf/poker';

import {
  WEB_POKER_CURRENCY_VALUES,
  WEB_POKER_GAME_STRUCTURE,
  WEB_POKER_GAME_TYPE,
  WEB_POKER_TABLE_TYPE
} from '../constants';
import { usePokerCashGamesWidget } from '../model';
import type { SliderValues } from '../types';
import { toInteger64 } from '../utils';

const useCGGameUrl = (selectedGames: SliderValues[]) => {
  const { resolver, ...payload } = useGameUrlPayload();
  const country = useSelector(select.account.getCountry);
  const { widgetSelect } = usePokerCashGamesWidget();
  const activeSliderIndex = useSelector(widgetSelect.getActiveSliderIndex);
  const activeGame = selectedGames[activeSliderIndex];

  if (!activeGame) return '';

  const linkConfig = {
    ...payload,
    gametype: WEB_POKER_TABLE_TYPE[activeGame.tableType],
    registeredCountryCode: country,
    seats: [activeGame.tableSize],
    stakes: [toInteger64(activeGame.smallBlind || 0), toInteger64(activeGame.bigBlind || 0)],
    minimumBuyIn: toInteger64(activeGame.minBuyIn || 0),
    maximumBuyIn: toInteger64(activeGame.maxBuyIn || 0),
    currencies: [
      WEB_POKER_CURRENCY_VALUES[activeGame.currency as keyof typeof WEB_POKER_CURRENCY_VALUES]
    ],
    games: [WEB_POKER_GAME_TYPE[activeGame.gameType as keyof typeof WEB_POKER_GAME_TYPE]],
    structures: [WEB_POKER_GAME_STRUCTURE[activeGame.bettingLimit]]
  };

  return generateGameUrl(linkConfig, resolver);
};

export default useCGGameUrl;
